import { render, staticRenderFns } from "./sos-distress.vue?vue&type=template&id=128f7236&scoped=true&"
import script from "./sos-distress.vue?vue&type=script&lang=js&"
export * from "./sos-distress.vue?vue&type=script&lang=js&"
import style0 from "./sos-distress.vue?vue&type=style&index=0&id=128f7236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f7236",
  null
  
)

export default component.exports